import { AuthenticatedHttpClient } from "@/lib/axios";
import {
  CategoryStatsList,
  DailyStatsList,
  EmailStatsList,
  SenderStats,
} from "@/types/statistics.types";

export class StatisticsService {
  private http: AuthenticatedHttpClient;

  constructor(httpClient: AuthenticatedHttpClient) {
    this.http = httpClient;
  }

  // async getEmailStatistics(params: { startDate: string; endDate: string }) {
  //   const response = await this.http.get("/statistics/email", { params });
  //   return response as unknown as SenderStatsList;
  // }

  async getDailyStatistics(params: { startDate: string; endDate: string }) {
    const response = await this.http.get(
      `/statistics/daily-stats?startDate=${params.startDate}&endDate=${params.endDate}`
    );
    return response as unknown as DailyStatsList;
  }

  async getSenderStatistics(params: { startDate: string; endDate: string }) {
    const response = await this.http.get(
      `/statistics/sender?startDate=${params.startDate}&endDate=${params.endDate}`
    );
    return response as unknown as SenderStats;
  }

  async getCategoryStatistics(params: { startDate: string; endDate: string }) {
    const response = await this.http.get(
      `/statistics/category-stats?startDate=${params.startDate}&endDate=${params.endDate}`
    );
    return response as unknown as CategoryStatsList;
  }

  async getInteractionsRangeStatistics(params: {
    startDate: string;
    endDate: string;
  }) {
    const response = await this.http.get(
      `/statistics/interactions/range?startDate=${params.startDate}&endDate=${params.endDate}`
    );
    return response as unknown as EmailStatsList;
  }

  // Fetch hostnames for IPs
  async fetchHostnames(data: {
    ips: string[];
    startDate: string;
    endDate: string;
  }) {
    return this.http.post<any>("/statistics/fetch-hostnames", data);
  }

  // Get senders with templates
  async getSendersWithTemplates(params: { startDate: string; endDate: string }) {
    const response = await this.http.get(
      `/statistics/senders-with-templates?startDate=${params.startDate}&endDate=${params.endDate}`
    );
    return response as unknown as { senders: import("@/types/dashboard.types").SenderWithTemplates[] };
  }

  // Get templates for specific sender
  async getSenderTemplates(senderEmail: string, params: { startDate: string; endDate: string }) {
    const encodedEmail = encodeURIComponent(senderEmail);
    const response = await this.http.get(
      `/statistics/sender-templates/${encodedEmail}?startDate=${params.startDate}&endDate=${params.endDate}`
    );
    return response as unknown as import("@/types/dashboard.types").SenderTemplatesResponse;
  }

  // Download IPs as CSV for a date (ipSource: "mailbox" | "sender")
  async downloadIps(params: { date: string; ipSource: "mailbox" | "sender" }) {
    return this.http.get<Blob>(
      "/statistics/download-ips",
      { date: params.date, ipSource: params.ipSource },
      "blob"
    );
  }

  // Download failed headers as ZIP (optional spfResult, dkimResult, dmarcResult filter by column)
  async downloadFailedHeaders(params: {
    date: string;
    spfResult?: boolean;
    dkimResult?: boolean;
    dmarcResult?: boolean;
  }) {
    const { date, spfResult, dkimResult, dmarcResult } = params;
    const query: Record<string, string | boolean> = { date };
    if (spfResult !== undefined) query.spfResult = spfResult;
    if (dkimResult !== undefined) query.dkimResult = dkimResult;
    if (dmarcResult !== undefined) query.dmarcResult = dmarcResult;
    return this.http.get<Blob>(
      "/statistics/download-failed-headers",
      query,
      "blob"
    );
  }
}
